import React, { useState } from 'react';

import LinkIcon from '@material-ui/icons/Link';
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';

const XeroContactList = ({ onSelect, contacts = [], contact, counterparts }) => {
  const [selectedContact, setSelectedContact] = useState(contact);

  const handleClick = value => {
    // if (value.AccountNumber) return;
    const updated = value === selectedContact ? undefined : value;
    setSelectedContact(updated);
    onSelect(updated);
    console.log(value)
  }

  return (
    <List>
      {
        contacts.map(contact => {
          const linked = counterparts.find(c => c.xeroContactId === contact.ContactID);
          const contactText = (contact.FirstName && contact.LastName) ? `${contact.FirstName} ${contact.LastName}` : contact.email?.trim() || contact.ContactID;
          const linkedText = linked ?  `Linked to ${linked.name}` : contactText;

          return <ListItem key={contact.ContactID} onClick={() => handleClick(contact)} selected={contact.ContactID === selectedContact?.ContactID} variant="text" color="default">
            <ListItemIcon>
              <LinkIcon color={contact.AccountNumber ? "secondary" : "primary"} />
            </ListItemIcon>
            <ListItemText primary={contact.Name} secondary={linkedText} />
          </ListItem>
        })
      }
    </List>
  );
}

export default XeroContactList;


